/* Koforto 主页交互：商品 Tab、故事圆圈弹窗、视频播放按钮、影片框。无依赖。 */
(() => {
  const PLAY = '<svg viewBox="0 0 14 16" aria-hidden="true"><path d="M0 0l14 8-14 8z" fill="currentColor"/></svg>';
  const PAUSE = '<svg viewBox="0 0 14 16" aria-hidden="true"><path d="M1 0h4v16H1zM9 0h4v16H9z" fill="currentColor"/></svg>';

  const once = (el, key) => { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; };

  const initTabs = (root) => root.querySelectorAll('[data-kfh-tabs]').forEach((wrap) => {
    if (!once(wrap, 'kfhReady')) return;
    const tabs = [...wrap.querySelectorAll('[role="tab"]')];
    const more = wrap.querySelector('[data-kfh-more]');
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = wrap.querySelector('#' + t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (more && tab.dataset.url) more.href = tab.dataset.url;
      if (focus) tab.focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        select(tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length], true);
      });
    });
  });

  // 小视频角落播放键：切换静音循环视频的声音/暂停
  const initPlay = (root) => root.querySelectorAll('[data-kfh-play]').forEach((btn) => {
    if (!once(btn, 'kfhReady')) return;
    const video = btn.parentElement.querySelector('video');
    if (!video) { btn.hidden = true; return; }
    const sync = () => {
      const on = !video.paused && !video.muted;
      btn.innerHTML = on ? PAUSE : PLAY;
      btn.classList.toggle('is-playing', on);
      btn.setAttribute('aria-label', on ? 'Pause video' : 'Play with sound');
    };
    btn.addEventListener('click', () => {
      if (video.paused || video.muted) { video.muted = false; video.currentTime = 0; video.play(); }
      else { video.pause(); video.muted = true; }
      sync();
    });
    video.addEventListener('pause', sync);
    sync();
  });

  // 影片框：点 "Watch the film" 开声音从头播放，加 controls
  const initFilm = (root) => root.querySelectorAll('[data-kfh-film]').forEach((frame) => {
    if (!once(frame, 'kfhReady')) return;
    const video = frame.querySelector('video');
    const chip = frame.querySelector('[data-kfh-film-play]');
    if (!video || !chip) { if (chip) chip.hidden = true; return; }
    chip.addEventListener('click', () => {
      video.muted = false; video.loop = false; video.controls = true; video.currentTime = 0; video.play();
      frame.classList.add('is-playing');
    });
    video.addEventListener('ended', () => { frame.classList.remove('is-playing'); video.controls = false; video.muted = true; video.loop = true; video.play(); });
  });

  // 故事圆圈：打开对应的 <dialog>
  const initStories = (root) => root.querySelectorAll('[data-kfh-story]').forEach((btn) => {
    if (!once(btn, 'kfhReady')) return;
    const dlg = document.getElementById(btn.getAttribute('aria-controls'));
    if (!dlg || typeof dlg.showModal !== 'function') return;
    const video = dlg.querySelector('video');
    btn.addEventListener('click', () => { dlg.showModal(); if (video) { video.currentTime = 0; video.play(); } });
    dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('[data-kfh-close]')) dlg.close(); });
    dlg.addEventListener('close', () => { if (video) video.pause(); });
  });

  const init = (root = document) => { initTabs(root); initPlay(root); initFilm(root); initStories(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
